














































import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';
import { State, Mutation, Action } from 'vuex-class';

@Component
export default class ToolNav extends Vue {
  @Prop() private rocketGlobal: any;
  @Prop() private rocketComps: any;
  @Mutation('SET_CURRENT_COMPS') private SET_CURRENT_COMPS: any;
  @Mutation('DELETE_COMPS_TREE') private DELETE_COMPS_TREE: any;
  @Mutation('ADD_COMPS_TREE') private ADD_COMPS_TREE: any;
  @Action('RUN_EVENTS') private RUN_EVENTS: any;
  private name: string = '';
  private template: string = 'nouse';
  private show: boolean = false;
  get type() {
    return this.rocketComps.tree[this.rocketComps.group].type;
  }
  private handleHide() {
    this.name = '';
    this.show = false;
  }
  private handleCreate() {
    if (!this.name) { return; }
    this.ADD_COMPS_TREE({name: this.name, template: this.template});
    this.handleHide();
    this.template = 'nouse';
  }
}
